<footer class="bg-gray-100 text-sm text-gray-700 border-t border-gray-200 ">
  <div class="h-1 bg-bnpp-green w-full"></div>
  <div class="flex gap-6 items-center justify-center px-4 py-6">
    <div class="flex items-center gap-2 justify-center">
      <img src="{{logoUrl()}}" alt="BNP Paribas Logo" class="h-8 w-auto" />
      <span class="font-semibold text-grey-800">The bank for a changing world</span>
    </div>
    <div class="flex flex-wrap  justify-center  gap-2 item-center  text-gray-500 ">
      <a routerLink="/contact" class="hover:text-green-700">Contact Us</a>
      <span>|</span>
      <a href="https://cib.bnpparibas/data-protection-notice/"
        appExternalLink="https://cib.bnpparibas/data-protection-notice/" class="hover:text-green-700">Data Protection
        Notice</a>
      <span>|</span>
      <div class="link"><a class="ot-sdk-show-settings" style="cursor: pointer;">Cookie Settings</a></div>
      <span>|</span>
      <a href="https://cib.bnpparibas/cookies-policy/" appExternalLink="https://cib.bnpparibas/cookies-policy/"
        class="hover:text-green-700">Cookies Policy</a>
      <span>|</span>
      <a routerLink="/termofuse" class="hover:text-green-700">Terms of Use</a>
      <span>|</span>
      <span class="hover:text-green-600">©BNP Paribas {{ currentYear }}</span>
    </div>
  </div>
</footer>
